// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Per-platform deploy guide rendered inside the Channels modal. Visual
   language matches the Telegram connect steps (numbered badges, tinted
   accent) but unified to the Ultimo Bots purple so every guide reads as one
   cohesive system regardless of the platform's own brand colour. */
.cguide {
  font-family: "DM Sans", sans-serif;
  color: #2b2b35;
}

/* ── Intro ─────────────────────────────────────────────────────────────
   Canonical info-box look for every Deploy → Channels modal.
   \`.integration-info-box\` in pages/integration.css mirrors it for the tabs
   that render through the Integration page (Chat link, Wix, Webflow,
   WordPress) — change both together. */
.cguide-intro {
  display: flex;
  gap: 14px;
  align-items: center;
  background: #f4efff;
  border: 1px solid #e4d9ff;
  border-left: 4px solid #5616ea;
  border-radius: 10px;
  padding: 14px 16px;
  margin-bottom: 18px;
}
.cguide-intro-icon {
  color: #5616ea;
  font-size: 19px;
  flex-shrink: 0;
}
.cguide-intro-body {
  min-width: 0;
}
.cguide-intro p {
  margin: 0 0 10px;
  font-size: 14px;
  line-height: 1.55;
  color: #3a3a45;
}
.cguide-embed-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11.5px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 999px;
  background: #fff;
  border: 1px solid #dccbff;
  color: #5616ea;
}
.cguide-embed-chip svg {
  font-size: 11px;
}

/* ── Plan caveat (which paid tier is needed) ───────────────────────── */
.cguide-plan {
  display: flex;
  align-items: center;
  gap: 9px;
  font-size: 13px;
  line-height: 1.45;
  color: #6a5417;
  background: #fff8e6;
  border: 1px solid #ffe7a3;
  border-radius: 9px;
  padding: 10px 13px;
  margin-bottom: 16px;
}
.cguide-plan svg {
  color: #d99a00;
  flex-shrink: 0;
}

/* ── Steps (vertical timeline) ─────────────────────────────────────── */
.cguide-steps {
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;
}
.cguide-step {
  position: relative;
  display: flex;
  gap: 14px;
  padding-bottom: 18px;
}
/* Connector line threading the numbered badges into one flow. */
.cguide-step::before {
  content: "";
  position: absolute;
  left: 13px;
  top: 30px;
  bottom: -2px;
  width: 2px;
  background: #e8e1fb;
}
.cguide-step:last-child {
  padding-bottom: 0;
}
.cguide-step:last-child::before {
  display: none;
}
.cguide-step-num {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  display: block;
  position: relative;
  z-index: 1;
}
.cguide-step-body {
  flex: 1 1;
  min-width: 0;
  padding-top: 2px;
}
.cguide-step-title {
  font-size: 14.5px;
  font-weight: 700;
  color: #20202a;
  margin-bottom: 3px;
}
.cguide-step-text {
  font-size: 13.5px;
  line-height: 1.55;
  color: #565662;
}
.cguide-step-title a,
.cguide-step-text a {
  color: #5616ea;
  font-weight: 600;
  text-decoration: none;
}
.cguide-step-title a:hover,
.cguide-step-text a:hover {
  text-decoration: underline;
}
.cguide-step-title code,
.cguide-step-text code {
  background: rgba(86, 22, 234, 0.09);
  color: #5616ea;
  padding: 1px 6px;
  border-radius: 5px;
  font-family: 'SFMono-Regular', Menlo, Consolas, 'Courier New', monospace;
  font-size: 0.85em;
}

/* ── Code block ────────────────────────────────────────────────────── */
.cguide-code-wrap {
  margin-top: 12px;
  border: 1px solid #e3d8ff;
  border-radius: 10px;
  overflow: hidden;
  background: #faf8ff;
}
.cguide-code-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 10px 8px 13px;
  background: #f1ebff;
  border-bottom: 1px solid #e3d8ff;
}
.cguide-code-lang {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 12px;
  font-weight: 700;
  color: #5616ea;
}
.cguide-copy {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: #5616ea;
  color: #fff;
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 600;
  padding: 6px 11px;
  border-radius: 7px;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.12s ease;
}
.cguide-copy:hover:not(:disabled) {
  background: #4a14d6;
  transform: translateY(-1px);
}
.cguide-copy:disabled {
  background: #c9bdf2;
  cursor: not-allowed;
}
.cguide-code {
  margin: 0;
  padding: 13px 14px;
  max-height: 230px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
}
.cguide-code code {
  font-family: 'SFMono-Regular', Menlo, Consolas, 'Courier New', monospace;
  font-size: 12.5px;
  line-height: 1.6;
  color: #2d2d2d;
}
.cguide-code-empty {
  padding: 14px;
  font-size: 13px;
  color: #82828e;
}

/* ── Note / caveat ─────────────────────────────────────────────────── */
.cguide-note {
  display: flex;
  align-items: center;
  gap: 9px;
  font-size: 13px;
  line-height: 1.5;
  color: #7a3a12;
  background: #fff3ec;
  border: 1px solid #ffd5bd;
  border-radius: 9px;
  padding: 11px 14px;
  margin-top: 18px;
}
.cguide-note svg {
  color: #f3742b;
  flex-shrink: 0;
}

/* ── Help-doc link ─────────────────────────────────────────────────── */
.cguide-doc {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 18px;
  font-size: 13.5px;
  font-weight: 600;
  color: #5616ea;
  text-decoration: none;
}
.cguide-doc svg {
  font-size: 12px;
}
.cguide-doc:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChannelGuide.css"],"names":[],"mappings":"AAAA;;;mEAGmE;AACnE;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;;;;uCAIuC;AACvC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;AACA,gEAAgE;AAChE;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,wEAAwE;EACxE,iBAAiB;AACnB;;AAEA,yEAAyE;AACzE;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,0BAA0B;EAC1B,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,wEAAwE;EACxE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B","sourcesContent":["/* Per-platform deploy guide rendered inside the Channels modal. Visual\r\n   language matches the Telegram connect steps (numbered badges, tinted\r\n   accent) but unified to the Ultimo Bots purple so every guide reads as one\r\n   cohesive system regardless of the platform's own brand colour. */\r\n.cguide {\r\n  font-family: \"DM Sans\", sans-serif;\r\n  color: #2b2b35;\r\n}\r\n\r\n/* ── Intro ─────────────────────────────────────────────────────────────\r\n   Canonical info-box look for every Deploy → Channels modal.\r\n   `.integration-info-box` in pages/integration.css mirrors it for the tabs\r\n   that render through the Integration page (Chat link, Wix, Webflow,\r\n   WordPress) — change both together. */\r\n.cguide-intro {\r\n  display: flex;\r\n  gap: 14px;\r\n  align-items: center;\r\n  background: #f4efff;\r\n  border: 1px solid #e4d9ff;\r\n  border-left: 4px solid #5616ea;\r\n  border-radius: 10px;\r\n  padding: 14px 16px;\r\n  margin-bottom: 18px;\r\n}\r\n.cguide-intro-icon {\r\n  color: #5616ea;\r\n  font-size: 19px;\r\n  flex-shrink: 0;\r\n}\r\n.cguide-intro-body {\r\n  min-width: 0;\r\n}\r\n.cguide-intro p {\r\n  margin: 0 0 10px;\r\n  font-size: 14px;\r\n  line-height: 1.55;\r\n  color: #3a3a45;\r\n}\r\n.cguide-embed-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 11.5px;\r\n  font-weight: 600;\r\n  padding: 4px 10px;\r\n  border-radius: 999px;\r\n  background: #fff;\r\n  border: 1px solid #dccbff;\r\n  color: #5616ea;\r\n}\r\n.cguide-embed-chip svg {\r\n  font-size: 11px;\r\n}\r\n\r\n/* ── Plan caveat (which paid tier is needed) ───────────────────────── */\r\n.cguide-plan {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 9px;\r\n  font-size: 13px;\r\n  line-height: 1.45;\r\n  color: #6a5417;\r\n  background: #fff8e6;\r\n  border: 1px solid #ffe7a3;\r\n  border-radius: 9px;\r\n  padding: 10px 13px;\r\n  margin-bottom: 16px;\r\n}\r\n.cguide-plan svg {\r\n  color: #d99a00;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* ── Steps (vertical timeline) ─────────────────────────────────────── */\r\n.cguide-steps {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  position: relative;\r\n}\r\n.cguide-step {\r\n  position: relative;\r\n  display: flex;\r\n  gap: 14px;\r\n  padding-bottom: 18px;\r\n}\r\n/* Connector line threading the numbered badges into one flow. */\r\n.cguide-step::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 13px;\r\n  top: 30px;\r\n  bottom: -2px;\r\n  width: 2px;\r\n  background: #e8e1fb;\r\n}\r\n.cguide-step:last-child {\r\n  padding-bottom: 0;\r\n}\r\n.cguide-step:last-child::before {\r\n  display: none;\r\n}\r\n.cguide-step-num {\r\n  flex-shrink: 0;\r\n  width: 28px;\r\n  height: 28px;\r\n  display: block;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n.cguide-step-body {\r\n  flex: 1;\r\n  min-width: 0;\r\n  padding-top: 2px;\r\n}\r\n.cguide-step-title {\r\n  font-size: 14.5px;\r\n  font-weight: 700;\r\n  color: #20202a;\r\n  margin-bottom: 3px;\r\n}\r\n.cguide-step-text {\r\n  font-size: 13.5px;\r\n  line-height: 1.55;\r\n  color: #565662;\r\n}\r\n.cguide-step-title a,\r\n.cguide-step-text a {\r\n  color: #5616ea;\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n}\r\n.cguide-step-title a:hover,\r\n.cguide-step-text a:hover {\r\n  text-decoration: underline;\r\n}\r\n.cguide-step-title code,\r\n.cguide-step-text code {\r\n  background: rgba(86, 22, 234, 0.09);\r\n  color: #5616ea;\r\n  padding: 1px 6px;\r\n  border-radius: 5px;\r\n  font-family: 'SFMono-Regular', Menlo, Consolas, 'Courier New', monospace;\r\n  font-size: 0.85em;\r\n}\r\n\r\n/* ── Code block ────────────────────────────────────────────────────── */\r\n.cguide-code-wrap {\r\n  margin-top: 12px;\r\n  border: 1px solid #e3d8ff;\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  background: #faf8ff;\r\n}\r\n.cguide-code-head {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n  padding: 8px 10px 8px 13px;\r\n  background: #f1ebff;\r\n  border-bottom: 1px solid #e3d8ff;\r\n}\r\n.cguide-code-lang {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  color: #5616ea;\r\n}\r\n.cguide-copy {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  border: none;\r\n  background: #5616ea;\r\n  color: #fff;\r\n  font-family: inherit;\r\n  font-size: 12.5px;\r\n  font-weight: 600;\r\n  padding: 6px 11px;\r\n  border-radius: 7px;\r\n  cursor: pointer;\r\n  transition: background 0.2s ease, transform 0.12s ease;\r\n}\r\n.cguide-copy:hover:not(:disabled) {\r\n  background: #4a14d6;\r\n  transform: translateY(-1px);\r\n}\r\n.cguide-copy:disabled {\r\n  background: #c9bdf2;\r\n  cursor: not-allowed;\r\n}\r\n.cguide-code {\r\n  margin: 0;\r\n  padding: 13px 14px;\r\n  max-height: 230px;\r\n  overflow: auto;\r\n  white-space: pre-wrap;\r\n  word-break: break-word;\r\n}\r\n.cguide-code code {\r\n  font-family: 'SFMono-Regular', Menlo, Consolas, 'Courier New', monospace;\r\n  font-size: 12.5px;\r\n  line-height: 1.6;\r\n  color: #2d2d2d;\r\n}\r\n.cguide-code-empty {\r\n  padding: 14px;\r\n  font-size: 13px;\r\n  color: #82828e;\r\n}\r\n\r\n/* ── Note / caveat ─────────────────────────────────────────────────── */\r\n.cguide-note {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 9px;\r\n  font-size: 13px;\r\n  line-height: 1.5;\r\n  color: #7a3a12;\r\n  background: #fff3ec;\r\n  border: 1px solid #ffd5bd;\r\n  border-radius: 9px;\r\n  padding: 11px 14px;\r\n  margin-top: 18px;\r\n}\r\n.cguide-note svg {\r\n  color: #f3742b;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* ── Help-doc link ─────────────────────────────────────────────────── */\r\n.cguide-doc {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-top: 18px;\r\n  font-size: 13.5px;\r\n  font-weight: 600;\r\n  color: #5616ea;\r\n  text-decoration: none;\r\n}\r\n.cguide-doc svg {\r\n  font-size: 12px;\r\n}\r\n.cguide-doc:hover {\r\n  text-decoration: underline;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
